import React from "react";
import AlbumDetailsContainer from "../../modules/OrganizationAlbums/containers/AlbumDetailsContainer/AlbumDetailsContainer";

const AlbumDetails = () => {
  return <AlbumDetailsContainer />;
};

export default AlbumDetails;
